import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'

import FieldInfo from 'components/FieldInfo'
import MediaUpload from 'components/MediaUpload'
import PriceField from 'components/PriceField'

import { AdobeExperiencePlatform } from 'components/Icons'
import SharedSections from './SharedSections'

const Product = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Image' labelFor='image'>
        <MediaUpload
          type='image'
          value={content.image || ''}
          maxHeight='100px'
          onUpload={onChange('image')}
          projectId={project?.meta?.id}
          path={`product-${screen?.meta?.name}-image`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Name' labelFor='product-name'>
        <FieldInfo title='AEP data' icon={<AdobeExperiencePlatform size='XS' />}>
          This field is used as a value for Product-related Experience Events in AEP
        </FieldInfo>
        <Textfield
          id='product-name'
          placeholder='Name'
          name='name'
          value={content.name || ''}
          onChange={onChange('name')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Price'>
        <PriceField
          placeholder='Price'
          name='price'
          value={content.price || null}
          onChange={onChange('price')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Description'>
        <Textfield
          placeholder='Description'
          name='description'
          value={content.description || ''}
          onChange={onChange('description')}
          disabled={disabled}
          multiLine
        />
      </FieldLabel>
    </>
  )
}

export default [{ label: 'Product', content: Product }, ...SharedSections]
